import { useRequestMedicalContext } from "../../Contexts/RequestMedicalTestContext";
import warningGeneral from "../../assets/warningGeneral.png";
import success from "../../assets/success.png";
import Button from "../../Components/Button";
import dayjs from "dayjs";
import {
  WarningRounded,
  CheckOutlined,
  CloseOutlined,
} from "@mui/icons-material";
import { Modal } from "@mui/material";

const BookingResultsModal = () => {
  const {
    setSelectedProcedureClass,
    selectedProcedureClass,
    setDisplaySummaryAlert,
    setSelectedProcedures,
    setDiagnosticOrders,
    displaySummaryAlert,
    setMappedProcedures,
    selectedProcedures,
    setSelectedOrders,
    setSelectedPolicy,
    setProcedureClass,
    setSelectedClinic,
    setFiles,
    navigate,
    setMonth,
    summary,
    setYear,
    setUrl,
    files,
  } = useRequestMedicalContext();

  const handleContinue = async () => {
    if (files.length > 0) {
      // Filter out the same objects from selectedProcedureClass
      const newSelectedProcedureClass = selectedProcedureClass.filter(
        (procedure) =>
          !summary.some(
            (item) =>
              item.message.message === "Appointment created!" &&
              item.data === procedure
          )
      );

      // Update newSelectedProcedureClass by adding an object with date and time properties
      const updatedSelectedProcedureClass = newSelectedProcedureClass.map(
        (procedure) => {
          const { date, time, ...rest } = procedure;
          return rest;
        }
      );

      // Update the state
      //setSummary([]);
      await setSelectedProcedureClass(updatedSelectedProcedureClass);
      setDisplaySummaryAlert(false);
      navigate("/request-medical-test/choose-date-time");
    } else {
      // Filter out the same objects from selectedProcedureClass
      const newSelectedProcedures = selectedProcedures.filter(
        (procedure) =>
          !summary.some(
            (item) =>
              item.message.message === "Appointment created!" &&
              item.data === procedure
          )
      );

      // Update newSelectedProcedureClass by adding an object with date and time properties
      const updatedSelectedProcedures = newSelectedProcedures.map(
        (procedure) => {
          const { date, time, ...rest } = procedure;
          return rest;
        }
      );
      // Update the state
      //setSummary([]);
      await setSelectedProcedures(updatedSelectedProcedures);
      setDisplaySummaryAlert(false);
      navigate("/request-medical-test/choose-date-time");
    }
  };

  const handleFinish = () => {
    setMonth(dayjs().format("MM"));
    setDisplaySummaryAlert(false);
    setSelectedProcedureClass([]);
    setYear(dayjs().year());
    setSelectedProcedures([]);
    setDiagnosticOrders([]);
    setSelectedOrders([]);
    setMappedProcedures();
    setSelectedPolicy(null);
    setProcedureClass();
    setSelectedClinic();
    setFiles([]);
    setUrl();
    navigate("/home");
  };

  const getIcon = () => {
    const allCreated = summary.every(
      (item) => item.message.message === "Appointment created!"
    );
    const noneCreated = summary.every(
      (item) => item.message.message !== "Appointment created!"
    );

    if (allCreated) {
      return <img src={success} className="w-[60px]" alt="success"/>;
    } else if (noneCreated) {
      return <img src={warningGeneral} className="w-[60px]" alt="success"/>;
    } else {
      return <WarningRounded sx={{ fontSize: "50px", color: "#ffcc00" }} />;
    }
  };

  const showContinue = () => {
    const allCreated = summary.every(
      (item) => item.message.message === "Appointment created!"
    );
    const noneCreated = summary.every(
      (item) => item.message.message !== "Appointment created!"
    );

    if (allCreated) {
      return null;
    } else if (noneCreated) {
      return (
        <div className="mt-2">
          <Button className="w-full text-white" onClick={handleContinue}>
            Edit booking
          </Button>
        </div>
      );
    } else {
      return (
        <div className="mt-2">
          <Button className="w-full text-white" onClick={handleContinue}>
            Edit booking
          </Button>
        </div>
      );
    }
  };

  return (
    <Modal
      open={displaySummaryAlert}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="flex items-center justify-center mb-3">
          {getIcon()}
        </div>
        <div className="text-center font-semibold mb-1">
          Booking Results
        </div>
        <div>
          {summary.map((data) => {
            return (
              <div key={data.procedure}
                className="flex items-center">
                {data.message.message === "Appointment created!" ? (
                  <CheckOutlined
                    fontSize="small"
                    sx={{ color: "#038913" }}
                  />
                ) : (
                  <CloseOutlined
                    fontSize="small"
                    sx={{ color: "#d92b2b"}}
                  />
                )}
                <p className="text-sm ml-2">{`${data.procedure} - ${data.message.message}`}</p>
              </div>
            );
          })}
        </div>

        {showContinue()}

        <div className="mt-2">
          <Button className="w-full bg-white border" onClick={handleFinish}>
            Finish
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default BookingResultsModal;
